import { HttpClient, HttpMethods } from "@planzone/services";

function getDocuments(httpClient: HttpClient) {
  return (namespace: string, type: string) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/folder/${type}/${namespace}/root`,
      method: HttpMethods.POST,
    });
}

export { getDocuments };
